'use client';
import { Box, Stack } from '@mui/material';
import { MarketingPageComponentProps } from '@services/launches/fetchLaunchMarketingContent';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import CustomImage from '@components/CustomImage';
import CommonContainer from '@components/CommonContainer';
import { fadeUpAosProps, getAosDelay, mergeAos } from '@utils/aosProps';
import SplideSlider from '@components/SplideSlider';
import cn from './style.module.scss';

export default function LsqSodicCompany(props: MarketingPageComponentProps) {
  const companySection = props?.locale?.section?.find(
    (section: any) => section.type === 'company' && section.enabled
  );
  if (!companySection) return null;
  const sliderOptions = {
    type: 'loop',
    rewind: true,
    pagination: true,
    arrows: true,
    autoplay: true,
    speed: 2000,
    interval: 6000,
  };
  return (
    <Stack
      component="section"
      className={cn.sodicCompanyWrapper}
      id="lsqSodicCompany"
    >
      <Box className={cn.sodicCompanyInner}>
        <CommonContainer
          paddingInline={{ xs: '1.25rem' }}
          maxWidth={{ sm: '100%', md: '1180px', lg: '1400px' }}
          flexGrow={1}
        >
          <Box className={cn.sodicCompanyBlock}>
            {companySection?.lsqSodicCompanyElements?.map(
              (item: any, index: number) => (
                <Box
                  key={index}
                  className={cn.sodicCompanyContent}
                  {...mergeAos(fadeUpAosProps, getAosDelay(index * 200))}
                >
                  {item?.logo && (
                    <Box className={cn.sodicCompanyLogo}>
                      <CustomImage
                        src={item.logo}
                        alt={`Company logo ${index + 1}`}
                        width={300}
                        height={100}
                      />
                    </Box>
                  )}
                  {item?.data && (
                    <Box className={cn.sodicCompanyData}>
                      <ParallaxText
                        variant="p"
                        animationType="zoomIn"
                        animationDuration={500}
                      >
                        {ReactHtmlParser(item.data)}
                      </ParallaxText>
                    </Box>
                  )}
                  {item?.slider?.length > 0 && (
                    <Box className={cn.sodicCompanyTheme}>
                      <SplideSlider
                        showArrows
                        blockClassName={cn.sodicCompanySliderPane}
                        arrowsClassName={cn.sodicCompanySliderArrows}
                        prevClassName={cn.sodicCompanySliderPrevious}
                        nextClassName={cn.sodicCompanySliderNext}
                        options={sliderOptions}
                      >
                        {item.slider.map((slide: any, slideIndex: number) => (
                          <Box key={slideIndex} className={cn.sodicDataElement}>
                            <Box className={cn.sodicDataElement__banner}>
                              <CustomImage
                                src={slide?.image?.url}
                                alt={slide?.image?.alt}
                                width={1920}
                                height={800}
                              />
                            </Box>
                            <Box className={cn.sodicDataElement__content}>
                              <Box className={cn.sodicDataContentLogo}>
                                <CustomImage
                                  src={slide?.content?.url}
                                  alt={slide?.image?.alt}
                                  width={1920}
                                  height={800}
                                />
                              </Box>
                              <Box className={cn.sodicDataContentButton}>
                                <a
                                  className={cn.sodicDataContentButtonLink}
                                  href={slide?.content?.href}
                                  target="_blank" rel="noopener noreferrer"
                                >
                                  {slide?.content?.button}
                                </a>
                              </Box>
                            </Box>
                          </Box>
                        ))}
                      </SplideSlider>
                    </Box>
                  )}
                </Box>
              )
            )}
          </Box>
        </CommonContainer>
      </Box>
    </Stack>
  );
}
